
export const plans = [
    {
        id: "free",
        name: "Free",
        price: "$0",
        description: "forever",
        highlight: false,
        features: [
            "1 active contest",
            "500 entries max",
            "Watermark included",
            "CSV export (post-contest)",
            "Embed on your site"
        ],
        badge: null
    },
    {
        id: "starter",
        name: "Starter",
        price: "$9",
        description: "/month",
        highlight: true,
        features: [
            "3 active contests",
            "Unlimited entries",
            "Analytics",
            "Branding control",
            "Additional data fields",
            "Abuse & fraud prevention",
            "Subtle RaffleKit branding"
        ],
        badge: "First 3 months free"
    },
    {
        id: "growth",
        name: "Growth",
        price: "$29",
        description: "/month",
        highlight: false,
        features: [
            "Everything in Starter",
            "Unlimited contests",
            "Unlimited entries",
            "Remove RaffleKit branding",
            "Integrations (Coming Soon)",
            "Priority support"
        ],
        badge: null
    }
];

export type PlanKey = 'free' | 'starter' | 'growth';
